<template>
  <div>
    <b-card :header="$t('subareas')"  header-tag="header" class=" header m-0 h-100">
      <!-- Header -->
      <template #header>
        <i class="mdi mdi-history mr-1" style="font-size: 1.3rem"></i>
        <strong class="mb-0 p-0">{{ $t('details') }}</strong>
      </template>
      <!-- Content -->
      <b-card-text class="text-left content">
        <b-spinner v-if="isLoading" label="Cargando..." variant="secondary" small class="mb-2" ></b-spinner>
        <div v-if="!isLoading">
          <div
            class="p-4"
            v-if="subareas.length"
          >
          <LmDatatableWithModalSelector
            datatableSlug="subareas-modal-internal"
            datatableModalSlug="subareas-modal-internal"
            @itemsAdded="onAddSubAreas"
            @itemsToRemove="onRemoveSubAreas"
            :hideTableSearcher="true"
            :hideTableFilter="true"
            :hideTableButtons="true"
            :items="subareas"
            :addItemButtonLabel="$t('add')"
            :emptyItemsMessage="$t('no_subareas_selected')"
            :removeConfirmationMessage="$t('subareas_remove_confirmation')"
            :isOnWidgetMode="false"
            :showFooterButtons="false"
          />
          </div>
          <LmError v-else/>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmError from '@/components/LmError.vue'
import LmDatatableWithModalSelector from '@/components/LmDatatableWithModalSelector'

export default {
  data () {
    return {
      isLoading: false,
      subareas: {}
    }
  },
  components: {
    LmError,
    LmDatatableWithModalSelector
  },
  computed: {
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    async getResponse () {
      try {
        this.isLoading = true

        const r = await commonsApi.axiosGetWrapper(`/areas/subareas/${this.value.id}`)

        this.subareas = r.data.subareas
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    emptyUserAvatar (m) {
      if (m.createdBy) {
        return m.createdBy?.user.firstname?.charAt(0) + m.createdBy?.user.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      return `${m.createdBy?.user.firstname} ${m.createdBy?.user.lastname}`
    },
    showDetails (index) {
      if (!this.movements.items[index].show) {
        this.movements.items[index].show = true
      } else {
        this.movements.items[index].show = false
      }
      this.$forceUpdate()
    }
  },
  created () {
    this.getResponse()
  }
}
</script>

<style scoped>
.content{
  max-height: 300px;
  margin-bottom: 23px;
  overflow: scroll;
}
</style>
